import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import ActiveBorrowersLanding from '../../../borrowers/ActiveBorrowersLanding';
import DeletedBorrowersLanding from '../../../borrowers/DeletedBorrowersLanding';
import BorrowersLanding from '../../../borrowers/BorrowersLanding';

export default function BorrowersRoutes() {
    return (
        <>
            <Route
                path='/borrowers/active'
                element={
                    <RequireAdmin>
                        <ActiveBorrowersLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/borrowers/recyclebin'
                element={
                    <RequireAdmin>
                        <DeletedBorrowersLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/borrowers'
                element={
                    <RequireAdmin>
                        <BorrowersLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
